<ng-container *ngIf="facetCategory && facetCategory.counts?.length > 0">
  <button (click)="toggleExpanded()"
          class="mb-facet-heading"
          data-cy="cms-facet-heading"
  >
    {{ getFacetCategoryName() }}
    <div class="collapse-icon mb-facet-collapse-button"
         data-cy="cms-facet-collapse-btn"
    ></div>
    <div class="expand-icon mb-facet-expand-button"
         data-cy="cms-facet-expand-btn"
    ></div>
  </button>
  <div [class.d-block]="isExpanded"
       [@smoothCollapse]="!isExpanded ? 'initial' : 'final'"
       data-cy="cms-facet-expand-container"
       style="overflow: hidden;"
  >
    <ng-container *ngFor="let facet of (facetCategory.counts ?? [])?.slice(0, showMoreThreshold)">
      <ng-container *ngTemplateOutlet="isReadonlyFacet(facet) ? readonlyFacet : facetLink; context: { facet: facet }"></ng-container>
    </ng-container>

    <div class="more"
         data-cy="cms-facet-more"
    >
      <div [@smoothCollapse]="showMore && !isMoreExpanded ? 'initial' : 'final'"
           [ngClass]="[showMore && isMoreExpanded ? 'd-block' : '']"
           data-cy="cms-facet-more-expand-container"
      >
        <ng-container *ngFor="let facet of (facetCategory.counts ?? [])?.slice(showMoreThreshold)">
          <ng-container *ngTemplateOutlet="isReadonlyFacet(facet) ? readonlyFacet : facetLink; context: { facet: facet }"></ng-container>
        </ng-container>
      </div>

      <button *ngIf="showMore && isMoreExpanded"
              (click)="isMoreExpanded = false"
              class="cx-action-link d-block"
              data-cy="cms-facet-less-button"
      >
        {{ 'searchFilterPane.showLess' | cxTranslate }}
      </button>

      <button *ngIf="showMore && !isMoreExpanded"
              (click)="isMoreExpanded = true"
              class="cx-action-link d-block"
              data-cy="cms-facet-more-button"
      >
        {{ 'searchFilterPane.showMore' | cxTranslate }}
      </button>
    </div>
  </div>
</ng-container>

<ng-template #facetLink
             let-facet="facet"
>
  <mb-link (clickEvent)="onFacetClick()"
           [linkData]="{uid: cmsLinkType.SPECIAL}"
           [queryParams]="getQueryParam(facet)"
           [styleClass]="['value', isFacetCountSelected(facet) ? 'selected' : '']"
           [useSlot]="true"
           dataCy="cms-facet"
           routerLink="./"
  >
      <span>
        <span class="label">{{ facet?.value ?? '' }}</span>
        <span class="count">{{ facet?.count ?? '' }}</span>
      </span>
  </mb-link>
</ng-template>
<ng-template #readonlyFacet
             let-facet="facet"
>
  <mb-link [class]="['value', 'selected', 'read-only-facet']"
           [linkData]="{uid: cmsLinkType.SPECIAL}"
           [useSlot]="true"
           dataCy="cms-facet"
  >
      <span>
        <span class="label">{{ facet?.value ?? '' }}</span>
        <span class="count">{{ facet?.count ?? '' }}</span>
      </span>
  </mb-link>
</ng-template>
